import { setCookie, removeCookie } from '@/services/cookie'
import session from '@/services/session'
import Storage from '@/services/storageLib'
import {endChatsAcrossTabs} from '@/services/broadcastChannel/broadcastChannelUtils'
import { GlobalVars } from '@/services/globals'
import { constantStrings, cookieConstant, chatEvents } from '@/services/constants'
import {isUserLoggedIn, getMinTimeForTypingIndicator, isBotRefIdOrWidgetIdChanged, isTypeBOT, getEndChatGreetingDelay, clearTimersUponEndChat, showMessageSeparatorPill, isEndChatSuveyValid, isSessionExpireSuveyValid, isEndChatGreetingValid } from '@/services/utils'
import customAttributes from '@/services/constants/customAttributes'
import mqttClient from '@/services/aws-iot/mqtt'
import store from '@/store'
import { emitEventToParentWindow, getEventDataPoints, handleEndChatSurveyError } from '@/services/utils'
import { eventType } from '@/services/constants'
import audioUtil from '../../services/audioUtil'
import VoiceState from '../../services/voiceConstants'
import streamHandler from '../../services/streamHandler'

let endChatSurveyTimeoutId = null
let endChatSurveyData = null

export default {
    clearChats({ commit }) {
        commit('CLEAR_CHATS')
    },
    updateClearConversationToPending({ commit }, data) {
        commit('UPDATE_CLEAR_CONVERSATION_STATUS_TO_PENDING', data)  
    },
    updateInputFieldDisableStatus({ commit }, data) {
        commit('UPDATE_INPUT_FIELD_DISABLE_STATUS', data)
    },

    updateInputFieldTempDisableStatus({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_TEMP_DISABLE_STATUS', data)
    },

    updateInputFieldTempDisableStatusTimer({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_TEMP_DISABLE_STATUS_TIMER', data)
    },

    updateInputFieldOnSendDisableTimer({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_ON_SEND_DISABLE_TIMER', data)
    },

    updateClearConversationStatus({ commit }, data) {
        commit('UPDATE_CLEAR_CONVERSATION_STATUS', data)
    },

    updateEndChatModalStatus({ commit }, data) {
        commit('UPDATE_END_CHAT_MODAL_STATUS', data)
    },

    updateEndChatModalOnChatRestart({ commit }, data) {
      commit('UPDATE_END_CHAT_MODAL_ON_CHAT_RESTART', data)
    },

    toggleShowHeaderDrawer({ commit }) {
      commit('TOGGLE_SHOW_HEADER_DRAWER')
    },
    
    updateInputFieldStreamingDisableStatus({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_STREAMING_DISABLE_STATUS', data)
    },

    updateInputFieldOnSendMessage({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_ON_SEND_DISABLE_STATUS', data)
    },

    async handleEndChat({ dispatch, rootState }, { data, callback = () => {}, hidePill = false, endChatClearConversation = true } = {}) {
      emitEventToParentWindow(eventType.CLOSE_SECURE_FORM_OVERLAY, {})
      dispatch('updateTypingIndicatorStatus', false)
      dispatch('clearFallbackMechanismTimer')
      endChatsAcrossTabs(data)
      /** 
        * If end chat is present in workflow instead of doing it manually, 
        we do not want to publish event to IOT to prevent multiple end chats 
      */
      if (!(data && Object.prototype.hasOwnProperty.call(data, constantStrings.PUBLISH_EVENT_TO_IOT)) || data[constantStrings.PUBLISH_EVENT_TO_IOT]) {
        await dispatch('sendIoTEvent',{event_name: 'END_CHAT', data})
      }  
      clearTimersUponEndChat()
      Storage.removeLocalStorageData('user-details', false)
      Storage.removeLocalStorageData('isAuth', false)
      removeCookie(cookieConstant.OAUTH.LOGGED_IN)
      setCookie(cookieConstant.GREETING.CALLOUT_BUBBLE_GREETING_COOKIE_LABEL, false)
      setCookie(cookieConstant.SESSION.CONVERSATION_INITIATED, false)
      dispatch('clearChatsWithAgentDesk')

      if (!hidePill) {
        // Show Flag to user if chat has ended
        showMessageSeparatorPill({
          message: data.message,
          isEndChatSeparator: true
        })
      }
      // send chat end / session expire event
      callback()
      Storage.removeLocalStorageData('endChatGreetingTriggered')
      Storage.removeLocalStorageData(constantStrings.DISMISS_CB_ON_CROSS)
      Storage.removeLocalStorageData(constantStrings.FILE_NAME_UUID)
      endChatClearConversation && dispatch('handleClearConversationStatus', rootState.widgetConfig?.endChatClearConversation || data?.clearConversation) // clearing chat after end chat if required
      audioUtil.endAudio()
      rootState.currentVoiceState = VoiceState.NONE
      dispatch('updateVoiceModeActive',false)
      if (data?.restartChat) {
        session.restartConversation()
      } else {
        session.endConversation() // End Previous Conversation
      }
      dispatch('handleAfterEndChatCases', { showSessionRestartGreeting: data?.showSessionRestartGreeting, isReset: data?.restartChat })
    },

    /**
     * This function is got trigger when user hit end chat from the menu option
     * It this we clear or reset certain things from current instance
     * -> Do end chat accross tabs
     * -> Clear cookie CALLOUT_BUBBLE_GREETING_COOKIE_LABEL, CONVERSATION_INITIATED
     * -> Clear chat with AgentDesk
     * -> End previous conversation
     * -> Unsubscribe MQTT
    */
    async endChat({ dispatch, rootState }, data) {
        emitEventToParentWindow(eventType.CLOSE_SECURE_FORM_OVERLAY, {})

        const isControlTypeBot = isTypeBOT(rootState.controlType)
        if (!isControlTypeBot) {
          const triggerResponseAttribute = customAttributes.triggerResponse()
          await GlobalVars.$liveAgent.endChatWithLiveAgent(triggerResponseAttribute)
        }
        
        if (store.getters.isPromptTestingEnable) {
          emitEventToParentWindow(eventType.CLEAR_CONVERSATION)
        }

        streamHandler.endChunkProcessing()

        const delay = getEndChatGreetingDelay() + getMinTimeForTypingIndicator()
        const isChatEndTypeSessionExpire = data.message === constantStrings.SESSION_HAS_EXPIRED
        const isSurveyFlowValid = isChatEndTypeSessionExpire ? isSessionExpireSuveyValid() : isEndChatSuveyValid()

        if (isSurveyFlowValid && !data?.restartChat && !store.getters.isPromptTestingEnable) { // check if survey to be shown upon end chat
          sendChatTerminationEvent(dispatch, data.message)
          dispatch('updateClearConversationToPending', 'pending')
          if (!data.hidePill) {
            showMessageSeparatorPill({
              message: data.message,
              isEndChatSeparator: true
            })
          }
          endChatSurveyData = data
          endChatSurveyTimeoutId = setTimeout(async () => {
            await endChatAfterSurvey(endChatSurveyData)
            endChatSurveyTimeoutId = null
            endChatSurveyData = null
          }, 6000)
        } else if (isEndChatGreetingValid(data.hideEndChatGreeting) && !data?.restartChat && !store.getters.isPromptTestingEnable) { // check if end chat greeting to be shown upon end chat
          if (!Storage.getLocalStorageData('endChatGreetingTriggered'))  {
            Storage.setLocalStorageData('endChatGreetingTriggered', true)
            dispatch('sendMessage', {
              userMessage: { 
              payload: rootState.widgetConfig?.endChat?.endChatGreeting, 
              label: constantStrings.PROACTIVE_GREETING_LABEL 
              }}
            )
          }
          setTimeout(async () => {
            await dispatch('handleEndChat', { 
              data, 
              callback: () => {
                if (!data?.restartChat) {
                  sendChatTerminationEvent(dispatch, data.message)
                }
              }, 
              hidePill: data.hidePill || false 
            })
          }, delay)
        } else { // ends the chat instantly
          await dispatch('handleEndChat', { 
            data, 
            callback: () => {
              if (store.getters.isPromptTestingEnable) return
              if (!data?.restartChat) {
                sendChatTerminationEvent(dispatch, data.message)
              }
            }, 
            hidePill: data.hidePill || false 
          })
        }
    },

    async endChatSurveyFulfilledBeforeTimeout() {
        if (endChatSurveyTimeoutId) {
          clearTimeout(endChatSurveyTimeoutId)
          endChatSurveyTimeoutId = null
          await endChatAfterSurvey(endChatSurveyData)
          endChatSurveyData = null
        }
    },

    handleAfterEndChatCases ({ rootState, dispatch }, { showSessionRestartGreeting = true, isReset = false } = {}) {
        dispatch('updateTermsAndConditions')
        if (isReset) {
          removeCookie(cookieConstant.GREETING.PROACTIVE_GREETING_COOKIE_LABEL)
          dispatch('triggerProActiveGreetings')
        }
        let restartGreetingTriggered = false
        if (rootState.widgetConfig.sessionRestartGreeting?.length && showSessionRestartGreeting) {
          restartGreetingTriggered = dispatch('triggerProActiveGreetings', true)
        }
        if (!restartGreetingTriggered && !isReset) {
          mqttClient.unsubscribe()
        }
        const {footerStatus} = rootState.widgetConfig
        if(!footerStatus) {
          dispatch('handleInputFieldStatusOnEndChat')
        }
        dispatch('updateBlankScreenState', { timerId: '' })
        dispatch('updateShowFormControls', false)
        dispatch('updateLastPendingFormStatus')
        !isUserLoggedIn() && dispatch('DELETE_PROACTIVE_GREETING_COOKIE')
        dispatch('updateQuickReplyOptions', []) // Clear Quick Reply Options if any
        dispatch('updateActionableNBAOptions', [])
        dispatch('updateUnreadMessagesState', { enabled: false })
        dispatch('updateNonActionableNBAOptions', [])
        dispatch('clearCSATState')
        if(rootState.widgetConfig?.inactiveOverlay?.showButtons) {
          dispatch('updateOverlayStatus', false)
          Storage.setLocalStorageData('overlayStatus', false)
        }
        dispatch('overlayIdleChatTimeout')
        dispatch('updateInputFieldDisableStatus', footerStatus && footerStatus === constantStrings.DISABLED)
        if (footerStatus && footerStatus === constantStrings.HIDDEN) {
          dispatch('updateInputFieldHiddenStatus', true)
        }
        dispatch('updateInputFieldStreamingDisableStatus', false)
        dispatch('updateAlerts')
        dispatch('updateInputFieldOnSendMessage', false)
    },

    handleClearConversationStatus ({ dispatch}, clearConversation = false) {
        if (clearConversation) {
          dispatch('clearChats')
          dispatch('updateClearConversationStatus', clearConversation)
        }
    },

    handleInputFieldStatusOnEndChat ({ dispatch, rootState }) {
        const oldWidgetConfig = { botRefId: rootState.botRefId, widgetId: rootState.widgetId } // botRefId & widgetId from vuex state
        const newWidgetConfig = Storage.getLocalStorageData('widgetConfig') // botRefId & widgetId from local storage
        const isChanged = isBotRefIdOrWidgetIdChanged(oldWidgetConfig, newWidgetConfig);
        dispatch('updateInputFieldDisableStatus', isChanged)
        if (!isChanged) {
          dispatch('updateInputFieldTempDisableStatus', isChanged)
        }
    },
}

const endChatAfterSurvey = async (data) => {
  await store.dispatch('handleEndChat', { data, callback: () => {}, hidePill: true, endChatClearConversation: false })
  handleEndChatSurveyError()
}

const sendChatTerminationEvent = (dispatch, message) => {
  const eventData = { 
    eventType: chatEvents.WIDGET_EVENT, 
    subType: message === constantStrings.SESSION_HAS_EXPIRED ? chatEvents.SESSON_EXPIRE: chatEvents.CHAT_END
  }
  if(message === constantStrings.SESSION_HAS_EXPIRED) {
    emitEventToParentWindow(eventType.SESSION_EXPIRE_PILL , getEventDataPoints())
  }
  else {
    emitEventToParentWindow(eventType.END_CHAT_PILL , getEventDataPoints())
  }
  dispatch('sendEvent', { eventData })
}
